import PropTypes from 'prop-types';

import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  legend: props => props.hidden && ({
    position: 'absolute',
    height: 1,
    width: 1,
    whiteSpace: 'nowrap', /* added line */
    overflow: 'hidden',
    clip: 'rect(1px, 1px, 1px, 1px)',
  }),
});

export default function Legend(props) {
  const classes = useStyles(props);
  return (
    <legend
      className={classes.legend}
      data-test={props.hidden ? 'Legend--hidden' : ''}
    >
      {props.children}
    </legend>
  );
}

Legend.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Legend.defaultProps = {
  hidden: false,
};
